module.exports = __webpack_public_path__ + "img/Betreuungstrupp.b73d65a2.svg";